module.exports = __webpack_public_path__ + "img/gricon4.87fde13c.png";